import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminPredefinedAnswerService } from '@/modules/predefined-answer/services/admin-predefined-answer.service'
import { PredefinedAnswerResourceModel } from '@/modules/predefined-answer/models/predefined-answer-resource.model'

@vservice()
export class PredefinedAnswerUpdateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminPredefinedAnswerService
  ) {
  }

  isSuccess = false
  isLoading = false

  execute(id: number, data: PredefinedAnswerResourceModel) {
    return this.service.update(id, { text: data.text })
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

}